import { StyleSheet } from 'react-native';

import { Fonts } from '../Themes';

export default StyleSheet.create({
  containerStyle: theme => ({
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.divider,
  }),
  titleStyle: theme => ({
    ...Fonts.type.bold,
    fontSize: 16,
    flex: 1,
    color: theme.colors.headerTitleColor,
    marginHorizontal: 18,
  }),
  leftIconStyle: {
    marginLeft: 5,
  },
});
